import React from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../components/Icon'

import './styles.css'

function DashboardCompletedFilterBreadcrumb({ onBack, prev, current }) {
    return (
        <div className="DashboardCompletedFilterBreadcrumb">
            <span
                className="DashboardCompletedFilterBreadcrumb__link"
                onClick={onBack}
            >
                <Icon
                    className="DashboardCompletedFilterBreadcrumb__icon"
                    name="arrow_back"
                />
                {prev}
            </span>
            <span className="DashboardCompletedFilterBreadcrumb__slash">/</span>
            <span className="DashboardCompletedFilterBreadcrumb__current">{current}</span>
        </div>
    )
}

DashboardCompletedFilterBreadcrumb.propTypes = {
    onBack: PropTypes.func.isRequired,
    prev: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
}

export default DashboardCompletedFilterBreadcrumb
